(function($) {
    $.GPSSimulator = function(options) {
        this._component_name = "gps_simulator";
        this._options = options || {};
        this.coordinates = { default: [] };
        this._default_location = 'default';
        this.current_coordinates = this.coordinates[this._default_location]; 

        this._simulator = null;

        this._events = {
            ready: "ready",
        };

        // bound methods
        this._on_simulaton_finished = this._on_simulaton_finished.bind(this);
        this._hide_history = this._hide_history.bind(this);
        this._btn_show_click = this._btn_show_click.bind(this);
        
        $.Component.call(this, $.GPSSimulator); 
    };

    $.Component.create($.GPSSimulator, {
        _init_: function(options) {
            this._options = options || {};
            this._buttons_container = this._options.buttons_container || '#buttons-overlay > .buttons-container';

            if (typeof(this._buttons_container) === 'string') {
                this._buttons_container = document.querySelector(this._buttons_container);
            }

            var paramsString = window.location.search || '';
            var searchParams = new URLSearchParams(paramsString); 
            
            if (searchParams.has('testgps') || (
                typeof(enable_test_gps) !== 'undefined' && enable_test_gps)) {
                var location = 'default';
                var speed = 40; 
        
                if (searchParams.has('location')) {
                    location = searchParams.get('location');
                }
                if (searchParams.has('speed')) {
                    speed = parseInt(searchParams.get('speed'));
                } 
        
                var repeat = false;
                if(searchParams.has('repeat')) {
                    repeat = true;
                }

                var path_button = false;
                if (searchParams.has('path_button')) {
                    path_button = true;
                }
                
                this._initialize_simulation(location, speed, repeat, path_button);    
            }

            if (searchParams.has('max-accuracy')) {
                var max_accuracy = parseFloat(searchParams.get('max-accuracy'));
                var btnStartTracking = document.getElementById('btnStartTracking');
                if (btnStartTracking != null) {
                    btnStartTracking.dataset.maxAccuracy = max_accuracy;
                }
            }
        },

        btnStartSimulationClicked: function(location, speed, repeat, evt) { 
            this._enable_scroll = true;
            
            if (typeof(this.parent.history) !== 'undefined') {
                this.parent.history.clear();
                this.parent.history.hide();
            }
    
            if (this._simulator == null) {
                this.parent.resetTracking(); 
                this._simulator = $.GeoSim(
                    {
                        coords: this.current_coordinates, 
                        speed: speed, 
                        onsimulationfinished: this._on_simulaton_finished,
                        tracker: this.parent,
                        repeat: repeat
                    });
    
                var started = this._simulator.start();
                if (started) {
                    this.parent.btnStartTrackingClick();
                    console.log('シムレーションが開始しました');
                }
                else {
                    console.log('シムレーションが開始できませんでした');
                }
            }
            else {
                this.parent.resetTracking(this._hide_history);
                this._simulator.restore();
                this._simulator = null;
                console.log('シムレーションが中止しました');
            }
        },

        _on_simulaton_finished: function() {
            this.parent.resetTracking(this._hide_history);
            this._simulator = null;
        },

        // todo move functionality to tracking_history.js
        _hide_history: function() { 
            if (typeof(this.parent.history) !== 'undefined') {
                this.parent.history.hide();
            }
        },

        _simulation_loaded: function(location, speed, repeat, path_button) { 
            this.current_coordinates = this.coordinates[location];
            if (typeof(this.coordinates[location]) === 'undefined') {
                alert(location + 'のシムレーションデータが存在しないから' + this._default_location + 'のデータを使わせていただきます');
                console.log(this._default_location+'のシムレーションデータを使っています');
            }
            else {
                this.current_coordinates = this.coordinates[location];
                console.log(location + 'のシムレーションデータを使っています');
            }
    
            console.log('GPSのシムレーションのスクリプトが読み込まれた'); 
     
            // select first immediate children of #buttons-overlay as a container  
            if(this._buttons_container) {
                var btnStartSimulation = document.createElement('button');
                btnStartSimulation.innerText = 'GPSテスト';
                btnStartSimulation.dataset.langkey = 'GPSテスト';
                btnStartSimulation.classList.add('btn_style_1','transition');
                this._buttons_container.prepend(btnStartSimulation); 
                
                btnStartSimulation.addEventListener(
                    ABDOUtil.getClickHandler(btnStartSimulation), 
                    this.btnStartSimulationClicked.bind(this, location, speed, repeat));

    
                if (path_button) {
                    var btnShow = document.createElement('button');
                    btnShow.innerText = 'GPSパス';
                    btnShow.dataset.langkey = 'GPSパス';
                    btnShow.classList.add('btn_style_1');
                    this._buttons_container.prepend(btnShow);
                    btnShow.addEventListener(
                        ABDOUtil.getClickHandler(btnShow), this._btn_show_click); 
                }
            }

            this._emit('ready');
        },

        _btn_show_click: function() {
            if (this._simulator == null) {
                alert('シミュレーションがまだ始まっていない');
                return;
            }
            this._simulator.toggleGPSRoute();
        },

        _initialize_simulation: function(location, speed, repeat, path_button) {
            // if (typeof($.GeoSim) === 'undefined') {
            //     var script = document.createElement('script');
            //     script.addEventListener('load', 
            //         this._simulation_loaded.bind(this, location, speed, repeat, path_button));
            //     script.src = '_abdo_location_simulator/js/geolocation-simulator.js'; 
            //     document.body.appendChild(script);
            // }
            // else {
            //     this._simulation_loaded(location, speed, repeat, path_button);
            // }
            this._simulation_loaded(location, speed, repeat, path_button);
        },

        _on_script_load: function() {
            this._simulation_loaded.call(self, location, speed, repeat, path_button); 
        },

        addSimulationData: function(name, data) {
            this.coordinates[name] = data;
        },

        setSimulationData: function(name) {
            if (name in this.coordinates) {
                this.current_coordinates = this.coordinates[name];
            }
        }, 

    }, $.Tracker);
 
}(ABDOMap));